import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex, Text } from 'components/ui';
import Accordion from 'components/Accordion/Accordion';
import { MAX_PRODUCTS } from 'components/Catalog/ProductGrid/CompareModal/constants';
import { zoneStyles } from 'components/Catalog/ProductGrid/CompareModal/Zones/zoneStyles';

const CompareZoneBase = ({ selectedProducts = [], getText = () => {}, titleKey, renderContent }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const zoneId = `compare-zone-${titleKey}`;
    const title = getText(titleKey);

    return (
        <Box css={zoneStyles.zoneSection}>
            <Accordion
                id={zoneId}
                title={title}
                isExpanded={isExpanded}
                onClick={() => setIsExpanded(!isExpanded)}
                customStyles={zoneStyles.accordionCustomStyles}
            >
                <Flex css={zoneStyles.productsContainer}>
                    {Array.from({ length: MAX_PRODUCTS }, (_, index) => {
                        const product = selectedProducts[index];
                        const isEmpty = !product;
                        const itemId = product?.productId || product?.parentProducts?.[0]?.productId;
                        const slotKey = itemId ? `product-${itemId}` : `slot-${index}`;

                        return (
                            <Box
                                key={slotKey}
                                css={zoneStyles.productSlot}
                            >
                                <Box css={zoneStyles.zoneContent}>
                                    {isEmpty ? (
                                        <Text
                                            fontSize='sm'
                                            color='gray'
                                        >
                                            -
                                        </Text>
                                    ) : (
                                        renderContent(product, index)
                                    )}
                                </Box>
                            </Box>
                        );
                    })}
                </Flex>
            </Accordion>
        </Box>
    );
};

CompareZoneBase.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func,
    titleKey: PropTypes.string.isRequired,
    renderContent: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(CompareZoneBase, 'CompareZoneBase');
